const t = {
  name: "Dubai",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 3.57414V0H7V9H5V11H7V22H4V24H20V22H16.525C16.8421 20.6921 17.002 19.3493 17 18.0002C17.0044 15.5798 16.4892 13.1935 15.4969 11H17V9H14.4259C13.0545 6.80155 11.1985 4.94556 9 3.57414ZM14.4588 22H9V11H13.2707C14.4095 13.1536 15.0047 15.5562 15 17.9981V18.0016C15.0021 19.3539 14.8198 20.6991 14.4588 22ZM9 9V5.99605C10.1387 6.84976 11.1502 7.86128 12.004 9H9Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Dubai
};
